// @ts-check
class ImageGallery extends HTMLElement {
	#galleryItems = /** @type {HTMLLIElement[]} */ ([]);
	#currentIndex = 0;

	constructor() {
		super();
	}

	connectedCallback() {
		const galleryItemsContainer = /** @type {HTMLElement} */ (
			this.querySelector(".HeroImageGallery-items")
		);

		if (!galleryItemsContainer) {
			return;
		}

		galleryItemsContainer.classList.add("HeroImageGallery-scrollbar--hidden");

		this.#galleryItems = Array.from(
			galleryItemsContainer.querySelectorAll(".js-HeroImageGallery-item"),
		);

		if (!this.#galleryItems.length) {
			return;
		}

		this.#setInitialCounterState();
		this.#addEventListeners();
	}

	#setInitialCounterState() {
		const counterCurrent = this.querySelector(
			".js-HeroImageGallery-metaCounterCurrent",
		);
		const counterTotal = this.querySelector(
			".js-HeroImageGallery-metaCounterTotal",
		);

		if (!counterCurrent || !counterTotal) {
			return;
		}

		counterCurrent.textContent = String(this.#currentIndex + 1);
		counterTotal.textContent = String(this.#galleryItems.length);
	}

	#updateCounterState() {
		const counterCurrent = this.querySelector(
			".js-HeroImageGallery-metaCounterCurrent",
		);

		if (!counterCurrent) {
			return;
		}

		counterCurrent.textContent = String(this.#currentIndex + 1);
	}

	#addEventListeners() {
		const controlsContainer = this.querySelector(".js-ImageGallery-controls");

		if (!controlsContainer) {
			return;
		}

		controlsContainer.addEventListener("click", (event) => {
			const target = /** @type {HTMLElement} */ (event.target).closest(
				"button",
			);

			if (!target) {
				return;
			}

			if (target.hasAttribute("data-previous")) {
				this.#currentIndex =
					this.#currentIndex === 0
						? this.#galleryItems.length - 1
						: this.#currentIndex - 1;
			} else if (target.hasAttribute("data-next")) {
				this.#currentIndex =
					this.#currentIndex === this.#galleryItems.length - 1
						? 0
						: this.#currentIndex + 1;
			}

			let scrollBehavior = /** @type {"auto" | "smooth"} */ ("smooth");
			if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
				scrollBehavior = "auto";
			}

			this.#updateCounterState();
			this.#galleryItems[this.#currentIndex].scrollIntoView({
				behavior: scrollBehavior,
				block: "nearest",
				inline: "nearest",
			});
		});
	}
}

customElements.define("image-gallery", ImageGallery);
